import { getRequest, postRequest } from "../util/axios";

//axios
//get请求
export let getAxios = (url, params) => {
  return getRequest(url, params);
};

//post请求 （json字符串参数）
export let postAxios = (url, body) => {
  return postRequest(url, body);
};
